import type {
  SatelliteWebLandlordGetLatestForContactsPageNoteDto,
  SatelliteWebLandlordGetLatestForContactsPageRequestDto,
} from '@zg-rentals/ts-satellite-client';
import {
  SatelliteConversationFolderTypeV2,
  SatelliteConversationReadRepliedStatusTypeV2,
  SatelliteConversationRenterProgressStatusTypeV2,
} from '@zg-rentals/ts-satellite-client';

export type GetContactsPageConversationsQueryParamsArgs = {
  clientTimeZone: string;
  endDateMs: number;
  limit: number;
  listingAlias?: string;
  start: number;
  startDateMs: number;
};

/**
 * Builds the request params for getLatestConversationsForContactsPage so that
 * cache updates (e.g. from SendMessageModal, Notepad) use the same key as the
 * query in LeadsTable.
 */
export function getContactsPageConversationsQueryParams({
  clientTimeZone,
  endDateMs,
  limit,
  listingAlias,
  start,
  startDateMs,
}: GetContactsPageConversationsQueryParamsArgs): SatelliteWebLandlordGetLatestForContactsPageRequestDto {
  return {
    clientTimeZone,
    startDateMs,
    endDateMs,
    folder: SatelliteConversationFolderTypeV2.INBOX,
    limit,
    start,
    ...(listingAlias && { listingAlias }),
    readRepliedStatus: SatelliteConversationReadRepliedStatusTypeV2.SHOW_ALL,
    renterProgressStatus: SatelliteConversationRenterProgressStatusTypeV2.SHOW_ALL,
  };
}

/**
 * Callback to update a conversation's note in the contacts page React Query cache.
 * Used when Notepad saves/deletes a note or toggles application sent from the contacts page
 * so the leads table reflects changes without refetching.
 */
export type OnContactsPageConversationNoteUpdate = (
  conversationId: string,
  noteUpdate: Partial<SatelliteWebLandlordGetLatestForContactsPageNoteDto>,
) => void;
